export const LanguageConstants = {
  SPACE: " ",
};
